import { isEmpty } from '../util/util';

export default (state, action) => {
  const { payload } = action;
  const { langStrings } = state;

  switch (action.type) {
    case 'TAKING_MORE_THAN_REQUIRED':
      return {
        ...state,
        loadingMoreThanRequired: true,
      }
    // Drowndown use case, when user choose product from dropdown.
    case 'ENTER_SERIAL_NUMBER':
      return {
        ...state,
        serialNumberAndProductName: payload,
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: true,
          showClose: false,
        },
        errors: {
          ...state.errors,
          invalidSerialNumber: false,
        },
      };
    // when user typing serial number, and dropdown is not available.   
    case 'ENTER_SERIAL_NUMBER_ONLY':
      return {
        ...state,
        serialNumberAndProductName: payload,
        currentHULADetails: {
          ...state.currentHULADetails,
          showClose: true,
          isLoading: false,
          // default params
          isICAssets: false,
          releaseList: [],
          authEmail: '',
          isSerialNumberValidated: false,
          showGreenTick: false,
          serialNumber: null,
          productName: null,
          productKey: null,
          productVersions: {},
          selectedProductVersion: null,
          productVersionKeys: {}, // product version and their keys.
          colName: null, // col Name for product selection field.
          crossGradeProducts: [], // cross grade API call response.
          selectedProduct: null, // when user choose product from product dropdown.
          productKeyMapping: {},
          isUserAdmin: false,      // Authorization page: options.
          suggestedCrosGradeProduct: [],
          loadingMoreThanRequired: false, // to show spin message update.
        },
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: false,
          showVersionDropdown: false,
        },
        errors: {
          ...state.errors,
          invalidSerialNumber: false,
        },
      };
    case 'ENTER_SERIAL_NUMBER_AND_PRODUCT':
      return {
        ...state,
        currentHULADetails:{
          ...state.currentHULADetails,
          serialNumber: payload.sNumber,
          productName: payload.prodName,
          selectedProduct: payload.prodName,
          isLoading: true,
          showClose: false,
        },
      }  
    case 'INVLID_SERIAL_NUMBER':
      return {
        ...state,
        errors:{
          ...state.errors,
          invalidSerialNumber: true,
        },
        currentHULADetails:{
          ...state.currentHULADetails,
          isLoading: false,
          showClose: true,
        },
      }
    case 'ENTER_CASE_DESCRIPTION':
      return {
        ...state,
        caseDescription: payload,
      }
    case'ENTER_REQUESTING_VERSION': 
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          selectedProduct: payload.selectedProduct,
          selectedProductVersion: payload.selectedVersion,
          productKey: payload.productKey,
        },
        errors: {
          ...state.errors,
          crossGradeHula: false,
        },
        caseError: {
          ...state.caseError,
          errorDesc: '',
        },
      }
    case'ENTER_REQUESTING_PRODUCT': 
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          selectedProduct: payload.selectedProduct,
          productVersions: payload.productVersions,
          crossGradeProducts: payload.crossGradeProducts,
          suggestedCrosGradeProduct: payload.suggestedCrosGradeProduct,
          productKey: payload.productKey ? payload.productKey : null,
          productVersionKeys: !isEmpty(payload.productVersionKeys) && payload.productVersionKeys,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showVersionDropdown: payload.showVersionDropdown,
        },
      }  
    case'CLEANUP_REQUESTING_PRODUCT':
      /*
        Note: 
        1. When customer choose product from dropdown, it execute 'ENTER_REQUESTING_PRODUCT' event.
        2. When customer change his mind, and choose product again from the dropdown then execute 
          'CLEANUP_REQUESTING_PRODUCT' to clean older data into React state. 
      */
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          selectedProduct: null,
          selectedProductVersion: null,
          productVersions: {},
          crossGradeProducts: [],
          suggestedCrosGradeProduct: [],
          productKey: null,
          productVersionKeys: {},
        },
        productInfoPage: {
          ...state.productInfoPage,
          showVersionDropdown: false,
        },
      }
    case 'ADD_PRODUCT_LIST': 
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          productVersions: payload.productVersions,
          productVersionKeys: payload.productVersionKeys,
          isICAssets: payload.isICAssets,
          isLoading: false,
          showClose: true,
          isSerialNumberValidated: true,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showVersionDropdown: payload.showVersionDropdown,
        },
      }
    case 'UPDATE_SERIAL_LIST':
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          isICAssets: payload.isICAssets,
          datalist: payload.serialList,
          assets: payload.assets,
          filteredSerialList: payload.serialList,
          serialListObject: payload.serialListObject,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showSerialList: payload.showSerialList,
          showSerialTextInput: payload.showSerialTextInput,
          showEligibleVersionDes: false,
          keepTyping: false,
        },
      };
    case 'SERIAL_NUMBER_VALIDATION': 
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: true,
          showClose: false,
          serialNumber: payload,
        },
      }
    case 'SHOW_GREEN_TICK':
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: false,       // loading spinner to disable
          showGreenTick: true,    // and show green tick.
        },
      }
    case 'DISABLE_GREEN_TICK':
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          showGreenTick: false,   // disable green tick.
          showClose: true,        // show close SVG icon.
        },
      }  
    case 'EXPAND_FOOTER_ON_ERROR': 
      return {
        ...state,
        expandFooterOnError: true,
      }
    case 'STORE_PRODUCT_AND_VERSION':
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          prodList: payload.prodList,
          productVersions: payload.productVersions,
          storeProductVersion: payload.productVersions, // backup.
          isICAssets: payload.assetType,
          productKeyMapping: payload.productKeyMapping,
          colName: payload.colName,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: true,
        },
      }
    case 'ENTER_AUTH_EMAIL': 
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          authEmail: payload,
        },
      }
    case 'ADD_ADMIN_STATUS':
      return {
        ...state,
        currentHULADetails: {
          ...state.currentHULADetails,
          isUserAdmin: payload,
        },
        caseError: {
          errorMessage: '',
          errorDesc: '',
        },
      };
    case 'CLEAR_PRODUCT_AND_VERSION_LIST':
      return {
        ...state,
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: false,
          showVersionDropdown: false,
        },
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: false, // HULA Serial Number validating(loading) is false initially.
          showClose: true,
          selectedProduct: null,
          selectedProductVersion: null,
          showGreenTick: false,
          serialNumber: null,
          productName: null,
          productKey: null,
          productVersions: {},
          productVersionKeys: {}, // product version and their keys.
          colName: null, // col Name for product selection field.
          crossGradeProducts: [], // cross grade API call response.
          productKeyMapping: {},
          isUserAdmin: false,      // Authorization page: options.
        },
      }
    case 'MULTIUSER_DEPLOYMENT': 
      return {
        ...state,
        errors: {
          ...state.errors,
          isMultiUserDeployment: true,
        },
        caseError: {
          ...state.caseError,
          errorDesc: langStrings.processInfoScreen.doNotNeedHula,
        },
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: false,
          showClose: true,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: false,
        },
      }  
    case 'HULA_NOT_ELIGIBLE': 
      return {
        ...state,
        errors: {
          ...state.errors,
          isHULAEligible: false,
        },
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: false,
          showClose: true,
        },
        caseError: {
          ...state.caseError,
          errorDesc: langStrings.processInfoScreen.ineligiblePerpetual,
        },
      }
    case 'CROSS_GRADE_HULA_MESSAGE': 
      return {
        ...state,
        errors: {
          ...state.errors,
          crossGradeHula: true,
        },
        caseError: {
          ...state.caseError,
          errorDesc: langStrings.hula.processInfoScreen.crossGradeHulaMessage,
        },
      }   
    case 'HULA_NO_LOGER_SUPPORTED': 
      return {
        ...state,
        errors: {
          ...state.errors,
          hulsNotEligible: true,
        },
        currentHULADetails: {
          isLoading: false,
          showClose: true,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: false,
        },
        caseError: {
          ...state.caseError,
          errorDesc: langStrings.processInfoScreen.msgSN2010orOlder,
        },
      }
    case 'HULA_TFLEX': 
      return {
        ...state,
        errors: {
          ...state.errors,
          isTFLEX: true,
        },
        currentHULADetails: {
          ...state.currentHULADetails,
          isLoading: false,
          showClose: true,
        },
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: false,
        },
        caseError: {
          ...state.caseError,
          errorDesc: langStrings.hula.errors.tokenFlexSerialNumber,
        },
      }  
    case 'UPDATE_HULA_ERROR': 
      return {
        ...state,
        caseError: {
          errorMessage: payload.errorMessage,
          errorDesc: payload.errorDesc,
        },
      }      
    case 'CLICK_CLOSE_ICON':
      return {
        ...state,
        serialNumberAndProductName: '',
        productInfoPage: {
          ...state.productInfoPage,
          showProductDropdown: false,
          showVersionDropdown: false,
        },
        currentHULADetails: {
          ...state.currentHULADetails,
          isICAssets: false,
          authEmail: '',
          isLoading: false, // HULA Serial Number validating(loading) is false initially.
          isSerialNumberValidated: false,
          showClose: false,
          showGreenTick: false,
          serialNumber: null,
          productName: null,
          productKey: null,
          productVersions: {},
          selectedProductVersion: null,
          productVersionKeys: {}, // product version and their keys.
          colName: null, // col Name for product selection field.
          crossGradeProducts: [], // cross grade API call response.
          selectedProduct: null, // when user choose product from product dropdown.
          productKeyMapping: {},
          isUserAdmin: false,      // Authorization page: options.
        },
        errors: {
          ...state.invalidSerialNumber,
          invalidSerialNumber: false,
          isMultiUserDeployment: false,
          isHULAEligible: true,
          hulsNotEligible: false,
          crossGradeHula: false,
          isTFLEX: false,
        },
        caseError: {
          ...state.caseError,
          errorDesc: '',
          errorMessage: '',
        },
      };      
    default:
      return state;
  }
};
